import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.availableTitleList = function (state, payload) {
  state.availableGoiList = []
  state.availableKanjiList = []
  state.availableBunPoList = []
  payload.forEach(row => {
    if (row.title_type === 1) {
      state.availableBunPoList.push(row)
    } else if (row.title_type === 2) {
      state.availableGoiList.push(row)
    } else {
      state.availableKanjiList.push(row)
    }
  })
}
mutations.commissionDetails = function (state, payload) {
  state.commissionDetails = payload
}
mutations.getLoginUserDetails = function (state, payload) {
  state.getLoginUserDetails = payload
}

const state = {
  availableTitleList: [],
  availableBunPoList: [],
  availableGoiList: [],
  availableKanjiList: [],
  commissionDetails: [],
  getLoginUserDetails: []
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        availableTitleList: {api: 'M0202TitleService.getAvailableTitleList'},
        commissionDetails: {api: 'M0301CommissionSettingService.getCommissionDetails'},
        getLoginUserDetails: {api: 'AuthService.getLoginUser'}
      }
    }

    return client.postData(ctx)
      .then((data) => {
        commit('availableTitleList', data.availableTitleList.output)
        commit('commissionDetails', data.commissionDetails.output)
        commit('getLoginUserDetails', data.getLoginUserDetails.output)
      })
  },
  enrollTitle: ({ commit, state }, titleDetails) => {
    console.debug('called M0201Chapter save')
    return client.postData({ data: { save: { api: 'M0202TitleService.updateTitleStatus', input: titleDetails } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0201Chapter cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0201Chapter search')
    return client.postData({ data: { search: { api: 'M0202TitleService.getTitleList', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0202Title/M0202TitleStore.js